

























import {
  computed, defineComponent, ref, toRefs, Ref, onMounted,
} from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import VueSkeleton from './vue-skeleton.vue';

const { useState: useStateSzukaj } = createNamespacedHelpers('szukaj');

export default defineComponent({
  components: { VueSkeleton },
  props: {
    url: {
      required: false,
      type: String,
      default: '',
    },
    alt: {
      required: false,
      type: String,
      default: '',
    },
    disabledForCrawler: {
      required: false,
      type: Boolean,
      default: false,
    },
    showSkeleton: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    loadImmediately: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { isFromCrawler } = useStateSzukaj(['isFromCrawler']);
    const {
      disabledForCrawler, loadImmediately, showSkeleton, width, height,
    } = toRefs(props);
    const isLoaded = ref(false);
    const onImageLoad = () => {
      isLoaded.value = true;
    };
    const imageWithSkeleton: Ref<HTMLDivElement | null> = ref(null);
    const imageSize = computed(() => ({
      width: width.value ? `${width.value}px` : '100%',
      height: height.value ? `${height.value}px` : '100%',
    }));

    const imageClasses: Ref<string[]> = ref([]);

    if (showSkeleton.value && context.parent && context.parent.$children[0].$vnode.data) {
      const className = context.parent.$children[0].$vnode.data['class'];
      const { staticClass } = context.parent.$children[0].$vnode.data;

      imageClasses.value = [className, staticClass];
      context.parent.$children[0].$vnode.data['class'] = undefined;
      context.parent.$children[0].$vnode.data.staticClass = undefined;
    }

    onMounted(() => {
      if (showSkeleton.value && imageWithSkeleton && imageWithSkeleton.value && imageWithSkeleton.value.classList.value) {
        imageClasses.value = imageWithSkeleton.value.classList.value.split(' ');
        imageWithSkeleton.value.classList.value = '';
      }
    });

    const showPlaceholder = computed(() => !isLoaded.value && showSkeleton.value);

    return {
      isLoaded,
      isLazy: computed(() => (loadImmediately.value ? false : disabledForCrawler.value ? !isFromCrawler.value : true)),
      onImageLoad,
      imageClasses,
      imageSize,
      showPlaceholder,
      imageWithSkeleton,
    };
  },
});
